import axios from 'axios';
import {backendHost} from '../../config';

export const getPromoCheckById = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/promo/check`, {params});
};